<div class="crypto-bid">
    <div class="mb-4">
        <span class="back pointer" (click)="goBack()"> <span class="back-arrow align-middle"> <i
                    class="fa fa-arrow-left"></i> </span>
            <span></span>Back </span>
           
    </div>
    <div class="row ">
        <div class="col-sm-12 col-lg-4" *ngIf="nftData">
            <div class="l-con">
                <div *ngIf="nftData.nftType != 'batch' " [hidden]="nftData.nftType == 'multibatch'">
                    <div class="image-con" [ngStyle]="{'background-image':'url( '+ nftData?.links[0]?.banner + ')'} "
                        *ngIf="nftData?.links[0]?.type == 'image'">
                    </div>
                    <div class="relative" *ngIf="nftData?.links[0]?.type == 'audio'">
                        <div class="overlay-play-btn"></div>
                        <div class="image-con"
                            [ngStyle]="{'background-image':'url( '+ nftData?.links[0]?.thumbnail + ')'} ">
                            <div class="button-on-img" (click)="playAudio('play')" *ngIf="showPlayBtn">
                                <i class="fa fa-play play-btn mt-20 pointer" aria-hidden="true"></i>
                            </div>
                            <div class="button-on-img" (click)="playAudio('pause')" *ngIf="!showPlayBtn">
                                <i class="fa fa-pause play-btn mt-20 pointer" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="position-absolute audio-track">
                            <audio controlsList="nodownload" (playing)="onPlayingAudio($event)" autoplay id="audio"
                                controls (pause)="playAudio('pause')" (play)="playAudio('play')">
                                <source src="{{nftData?.links[0]?.banner}}">
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    </div>
                    <div class="relative" *ngIf="nftData?.links[0]?.type == 'video'">
                        <div class="overlay-play-btn"></div>
                        <!-- <div class="image-con" [ngStyle]="{'background-image':'url( '+ nftData?.links[0]?.thumbnail + ')'} ">
                        <div class="button-on-img" (click)="playAudio()" *ngIf="showPlayBtn">
                            <i class="fa fa-play play-btn mt-20 pointer"  aria-hidden="true"></i>
                        </div>
                    </div> -->
                        <div class="w-100">
                            <video width="350" height="240" controls playsinline autoplay controlsList="nodownload">
                                <source src="{{nftData?.links[0]?.banner}}" type="video/mp4">
                                <source src="movie.ogg" type="video/ogg">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
                <div class="batch" *ngIf="batchMintStaticData.length">
                    <div class="image-con"
                        [ngStyle]="{'background-image':'url( '+ batchMintStaticData[active]?.file + ')'} "
                        *ngIf="batchMintStaticData[active]?.type == 'image'">
                    </div>
                    <div class="relative" *ngIf="batchMintStaticData[active]?.type == 'audio'">
                        <div class="overlay-play-btn"></div>
                        <div class="image-con"
                            [ngStyle]="{'background-image':'url( '+ nftData?.links[0]?.banner + ')'} ">
                            <div class="button-on-img" (click)="playAudio('play')" *ngIf="showPlayBtn">
                                <i class="fa fa-play play-btn mt-20 pointer" aria-hidden="true"></i>
                            </div>
                            <div class="button-on-img" (click)="playAudio('pause')" *ngIf="!showPlayBtn">
                                <i class="fa fa-pause play-btn mt-20 pointer" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="position-absolute audio-track">
                            <audio controlsList="nodownload" (playing)="onPlayingAudio($event)" autoplay
                                id="audio[active]" controls (pause)="playAudio('pause')" (play)="playAudio('play')">
                                <source src="{{batchMintStaticData[active]?.file}}">
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    </div>
                    <div class="relative" *ngIf="batchMintStaticData[active]?.type == 'video'">
                        <div class="overlay-play-btn"></div>

                        <div class="w-100">
                            <video width="350" height="240" controls playsinline autoplay controlsList="nodownload">
                                <source src="{{batchMintStaticData[active]?.file}}" type="video/mp4">
                                <source src="movie.ogg" type="video/ogg">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                    <div class="batchmint-container">
                        <ng-container *ngFor="let item of batchMintStaticData; let i= index">
                            <div class="batchmint-item position-relative" *ngIf="item.type=='image'"
                                [ngStyle]="{'background-image':'url( '+ batchMintStaticData[i]?.file + ')'} "
                                (click)="active = i">
                                <div class="position-absolute" [ngClass]="{'overlay' : i != active}"></div>
                            </div>
                            <div class="batchmint-item position-relative" *ngIf="item.type=='audio'"
                                [ngStyle]="{'background-image':'url( '+ nftData?.links[0]?.banner + ')'} "
                                (click)="active = i">
                                <div [ngClass]="{'overlay' : i != active}">
                                    <i class="fa fa-play play-btn  pointer position-absolute" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="batchmint-item position-relative" *ngIf="item.type=='video'"
                                [ngStyle]="{'background-image':'url( '+ nftData?.links[0]?.banner + ')'} "
                                (click)="active = i">
                                <div  [ngClass]="{'overlay' : i != active}">
                                    <i class="fa fa-play play-btn  pointer position-absolute" aria-hidden="true"></i>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="vendor-con" *ngIf="collectionDetails">
                    <h6 class="heading">About Collection</h6>
                    <div class="about-img-con">
                        <div class="img"
                            [ngStyle]="{'background-image':' url(' + collectionDetails?.banner_image + ')'} "></div>
                        <div class="name">{{collectionDetails.name}}</div>
                    </div>
                    <div class="about" [ngStyle]=" showMore && {'height':'auto'}">{{collectionDetails?.description}}
                    </div>
                    <div (click)="showMore = !showMore" class="pointer show-more"
                        *ngIf="collectionDetails?.description.length > 70">
                        <span *ngIf="!showMore">Show More+</span>
                        <span *ngIf="showMore">Show Less-</span>
                    </div>
                </div>

                <div class="panel-2">
                    <h3 class="h3">Details</h3>
                    <div class="row gy-3">
                        <div class="col-6">
                            <p class="para">Contract Address</p>
                        </div>
                        <div class="col-6 text-right">
                            <p class="para1">{{contractAddress | slice:0:5}}...{{contractAddress | slice:-4:-1}}</p>
                        </div>
                        <div class="col-6">
                            <p class="para">Token Id</p>
                        </div>
                        <div class="col-6 text-right">
                            <p class="para1">{{nftData.tokenId}}</p>
                        </div>
                        <div class="col-6">
                            <p class="para">Token Standard</p>
                        </div>
                        <div class="col-6 text-right">
                            <p class="para" *ngIf="nftData.nftType == 'single'">ERC-721</p>
                            <p class="multiple" *ngIf="nftData.nftType == 'multiple'">ERC-1155</p>
                        </div>
                        <div class="col-6">
                            <p class="para">Blockchain</p>
                        </div>
                        <div class="col-6 text-right">
                            <p class="para">{{network_name}}</p>
                        </div>
                        <div class="col-6">
                            <p class="para">Creator Fees</p>
                        </div>
                        <div class="col-6 text-right">
                            <p class="para">{{nftData.royalities}}%</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- Top-Right  -->
        <!-- -------------------------------------------------------------------------------------------- -->
        <div class=" col-sm-12 col-lg-8">
            <div *ngIf="nftData">
                <div class="row no-gutters b-btm mb-2">
                    <div class="col-8">
                        <div class="name-con">
                            <h6 class="nft-event-orgn mb-20" *ngIf="collectionDetails">{{collectionDetails.name}}</h6>
                            <h5 class="nft-event-name">{{nftData.name}}</h5>
                        </div>
                    </div>
                    <div class="col-4 text-right" [hidden]="true">
                        <i class="fa fa-heart-o fs-26 pointer"></i>
                    </div>
                </div>
                <div class="row price-content aling-items-center">
                    <div class="col-sm-12 col-md-12 col-lg-7 d-flex">
                        <div class="rw2 mr-15">
                            <p class="P2" *ngIf="nftData.nftType!='batch' && nftData.nftType!='multibatch'">Current Price</p>
                            <p class="P2" *ngIf="nftData.nftType =='batch' || nftData.nftType =='multibatch'">Batch Price</p>
                            <div class="P3"><img class="mb-1" src="{{cryptoSymbol}}" width="20">
                                <span class="usd-amount" *ngIf="nftData.saleType!='auction'">{{nftData.salePrice}}
                                    {{nftData.token_type ==='GFL' ? nftData.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}}<span class="fs-20 fiat-currency">
                                        ({{nftFiatPrice | currency : getCurrency }})</span></span>
                                <span class="usd-amount" *ngIf="nftData.saleType=='auction'">{{highestBid}}
                                    {{nftData.token_type ==='GFL' ? nftData.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}}<span class="fs-20 fiat-currency">
                                        ({{ nftHighestBidFiatCurrency | currency : getCurrency }})</span></span>
                            </div>
                        </div>
                        <div class="rw2  ml-15" *ngIf="nftData.saleType=='auction'">
                            <p class="P2">Listed Price</p>
                            <div class="P3"><img class="mb-1" src="{{cryptoSymbol}}" width="20">
                                <span class="usd-amount" *ngIf="nftData.saleType=='auction'">{{nftData.salePrice}}
                                    {{nftData.token_type ==='GFL' ? nftData.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}}<span class="fs-20 fiat-currency">
                                        ({{ nftFiatPrice | currency : getCurrency }})</span></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-5 d-flex justify-content-end">
                        <div class="rw2 text-right mr-2" *ngIf="nftData.token_type === 'KP' && !(nftData.saleType =='auction' && saleDetails.saleStatus == -1)">
                            <mat-form-field appearance="fill" class="w-100">
                                <mat-label>Choose Token</mat-label>
                                <mat-select [(ngModel)]="selectedToken"
                                    (selectionChange)="onTokenSelect($event.value)">
                                    <mat-option [value]="'KO+'">{{clientDetails?.name=="BigbeeAI"?"BB":"KO+"}}</mat-option>
                                    <mat-option [value]="'GFL'">GFL</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="rw2 text-right mr-2">
                            <button class="btn" (click)="openrightnav()"
                                *ngIf="nftData?.saleType == 'auction' && nftBidInfo && nftData.number_of_copies_for_sale > 0 && saleDetails.saleStatus > 0"
                                >
                                <span *ngIf="nftBidInfo?.length">Increase Bid</span>
                                <span *ngIf="nftBidInfo?.length == 0">Make Bid</span>
                            </button>
                        </div>
                        <!-- <div class="rw2 text-right">
                            <button class="btn" *ngIf="nftBidInfo?.length" (click)="onWithdrawBid()">
                                <span>Withdraw Bid</span>
                            </button>
                        </div> -->
                        <div class="rw2 text-right">
                            <button class="btn buy-btn" (click)="openrightnav()"
                                *ngIf="((nftData.saleType == 'instant' || nftData.saleType == 'lazymint') && (nftData.nftType=='single' || nftData.nftType =='batch' || nftData.nftType =='multibatch' ) && nftData.number_of_copies_for_sale > 0 ) || (nftData.nftType=='multiple' && nftData.saleType == 'instant' && nftData.number_of_copies_for_sale > 0 && collectionDetails.id != 'Avalanche' && collectionDetails.id != 'Polygon')">
                                Buy
                            </button>
                            <!-- <button class="btn" (click)="toggleResaleSideBar()"
                        *ngIf="nftData.saleType == 'instant' && nftData.bought_by == accountNumber">Resale</button>     -->
                        </div>
                    </div>
                </div>
                <div class="rw3 mt-25">
                    <h2 class="h2">Description</h2>
                    <p class="nft-description" [ngStyle]=" showMore1 && {'height':'auto'}"> {{nftData.description}}</p>
                    <div (click)="showMore1 = !showMore1" class="pointer show-more"
                        *ngIf="nftData.description.length > 200">
                        <span *ngIf="showMore1">Show Less-</span>
                        <span *ngIf="!showMore1">Show More+</span>
                    </div>
                </div>
                <div class="rw4" *ngIf="nftData.saleType =='auction' && saleDetails.saleStatus != -1">
                    <h1 class="h1">{{saleDetails.saleText}}</h1>
                    <div class="timer">
                        <div class="box">
                            <div>
                                <label class="time">{{days}}</label>
                                <p class="time-label">Days</p>
                            </div>
                        </div>
                        <div class="box">
                            <div>
                                <label class="time">{{hours}}</label>
                                <p class="time-label">Hours</p>
                            </div>
                        </div>
                        <div class="box">
                            <div>
                                <label class="time">{{minutes}}</label>
                                <p class="time-label">Minutes</p>
                            </div>
                        </div>
                        <div class="box">
                            <div>
                                <label class="time">{{seconds}}</label>
                                <p class="time-label">Seconds</p>
                            </div>
                        </div>

                    </div>
                    <p class="time-p"> {{event.sale_end_time | date:'long'}}</p>
                </div>
                <div class="rw4" *ngIf="nftData.saleType =='auction' && saleDetails.saleStatus == -1">
                    <h1 class="h1 text-center">{{saleDetails.saleText}}</h1>
                </div>
                <section class="Tabel" *ngIf="dataSourceResale.data?.length > 0">
                    <div id="accordion3">
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <h5 class="mb-0 pointer heading" data-toggle="collapse" data-target="#collapseThree"
                                    aria-expanded="true" aria-controls="collapseThree">
                                    <div class="row aling-items-center">
                                        <div class="col-6">Listing</div>
                                        <div class="col-6 text-right"><i class="fa fa-angle-down"></i></div>
                                    </div>
                                </h5>
                            </div>

                            <div id="collapseThree" class="collapse show card-body table-responsive"
                                aria-labelledby="headingOne" data-parent="#accordion3">
                                <table mat-table [dataSource]="dataSourceResale" class=" w-100"
                                    *ngIf="dataSourceResale.data?.length > 0">


                                    <!-- <ng-container matColumnDef="Name">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                                        <td mat-cell *matCellDef="let row"> {{row.name}} </td>
                                    </ng-container> -->


                                    <ng-container matColumnDef="Price">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Price </th>
                                        <td mat-cell *matCellDef="let row"><img src="{{cryptoSymbol}}" width="14"
                                                class="mb-1" /> {{row.salePrice}} {{nftData.token_type ==='GFL' ? nftData.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="NFTType">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantity </th>
                                        <td mat-cell *matCellDef="let row"> {{row.number_of_copies_for_sale}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Creator">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Owner </th>
                                        <td mat-cell *matCellDef="let row">
                                            <span class="wallet-id" *ngIf="row.listed_by != 'owner'">{{row.listed_by |
                                                slice:0:3}}....{{row.listed_by | slice:-4}}</span>
                                            <span class="wallet-id" *ngIf="row.listed_by == 'owner'">{{row.wallet_id |
                                                slice:0:3}}....{{row.wallet_id | slice:-4}}</span>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="Copies">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                                        <td mat-cell *matCellDef="let row"> <button type="button" class="resale-buy-btn"
                                                *ngIf="row.number_of_copies_for_sale > 0 && row.saleType == 'instant'"
                                                (click)="openrightnav(row.nft_id,row)">Buy</button>
                                            <button type="button" class="resale-buy-btn"
                                                *ngIf="row.number_of_copies_for_sale > 0 && row.saleType == 'auction' && saleDetails.saleStatus > 0"
                                                (click)="openrightnav(row.nft_id,row)"> {{nftBidInfo?.length > 0?
                                                'Increase':'Make'}} Bid</button>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsResale"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsResale;"></tr>
                                </table>
                                <div class="d-flex justify-content-center align-items-center"
                                    *ngIf="dataSourceResale.data.length == 0">
                                    No Records Found
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <mat-paginator #resalePaginator [pageSizeOptions]="[5,10,25,100]" showFirstLastButtons
                    [hidden]="dataSourceResale.data?.length <= 5">
                </mat-paginator>
            </div>
            <div id="accordion4" [hidden]="chartData.length <= 1">
                <div class="card">
                    <div class="card-header" id="headingOne">
                        <h5 class="mb-0 pointer heading" data-toggle="collapse" data-target="#collapseFour"
                            aria-expanded="true" aria-controls="collapseFour">
                            <div class="row aling-items-center">
                                <div class="col-6">Price History</div>
                                <div class="col-6 text-right"><i class="fa fa-angle-down"></i></div>
                            </div>
                        </h5>
                    </div>
                    <div id="collapseFour" class="collapse show card-body" aria-labelledby="headingThree"
                        data-parent="#accordion4" [hidden]="chartData.length <= 1">
                        <div class="chart-container">
                            <canvas id="MyChart">{{ chart }}</canvas>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <section class="Tabel" *ngIf="nftData?.saleType == 'instant' && dataSource.data?.length > 0">
        <div id="accordion1">
            <div class="card">
                <div class="card-header" id="headingOne">
                    <h5 class="mb-0 pointer heading" data-toggle="collapse" data-target="#collapseOne"
                        aria-expanded="true" aria-controls="collapseOne">
                        <div class="row aling-items-center">
                            <div class="col-6">Item History</div>
                            <div class="col-6 text-right"><i class="fa fa-angle-down"></i></div>
                        </div>
                    </h5>
                </div>

                <div id="collapseOne" class="collapse show card-body table-responsive" aria-labelledby="headingOne"
                    data-parent="#accordion1">
                    <table mat-table [dataSource]="dataSource" class=" w-100" *ngIf="dataSource.data?.length > 0">


                        <ng-container matColumnDef="Event">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Event </th>
                            <td mat-cell *matCellDef="let row"> {{row.action}} </td>
                        </ng-container>


                        <ng-container matColumnDef="Offerprice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit price </th>
                            <td mat-cell *matCellDef="let row"><img src="{{cryptoSymbol}}" width="14" class="mb-1" />
                                {{row.price}} {{nftData.token_type ==='GFL' ? nftData.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}}</td>
                        </ng-container>

                        <ng-container matColumnDef="Quantity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantity </th>
                            <td mat-cell *matCellDef="let row"> {{row.number_of_copies}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Expiration">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                            <td mat-cell *matCellDef="let row"> {{row.transaction_date}} </td>
                        </ng-container>
                        <ng-container matColumnDef="From">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> From </th>
                            <td mat-cell *matCellDef="let row"><span class="wallet-id">{{row.from |
                                    slice:0:3}}....{{row.from | slice:-4}}</span> </td>
                        </ng-container>
                        <ng-container matColumnDef="To">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> To </th>
                            <td mat-cell *matCellDef="let row"> <span class="wallet-id">{{row.wallet_id |
                                    slice:0:3}}...{{row.wallet_id | slice:-4}}</span> </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div class="d-flex justify-content-center align-items-center" *ngIf="dataSource.data?.length == 0">
                        No Records Found
                    </div>
                </div>
            </div>

        </div>
    </section>
    <mat-paginator #paginator [pageSizeOptions]="[5,10,25,100]" showFirstLastButtons
        [hidden]="dataSource.data?.length<=5">
    </mat-paginator>

    <section class="Tabel" *ngIf="nftData?.saleType != 'instant' && auctionDetails?.length>0">

        <div id="accordion2">
            <div class="card">
                <div class="card-header" id="headingOne">
                    <h5 class="mb-0 pointer heading" data-toggle="collapse" data-target="#collapseTwo"
                        aria-expanded="true" aria-controls="collapseTwo">
                        <div class="row aling-items-center">
                            <div class="col-6">Auction History</div>
                            <div class="col-6 text-right"><i class="fa fa-angle-down"></i></div>
                        </div>
                    </h5>
                </div>

                <div id="collapseTwo" class="collapse show card-body" aria-labelledby="headingOne"
                    data-parent="#accordion2">
                    <ng-container *ngIf="auctionDetails?.length>0">
                        <table mat-table [dataSource]="dataSourceAuction" class=" w-100">
                            <ng-container matColumnDef="Offerprice">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-25 text-capitialize">
                                    Unit price </th>
                                <td mat-cell *matCellDef="let row" class="w-25 "><img src="{{cryptoSymbol}}" width="14"
                                        class="mb-1" />
                                    {{row.price}} {{nftData.token_type ==='GFL' ? nftData.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}} </td>
                            </ng-container>

                            <ng-container matColumnDef="From">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-25 text-capitialize">
                                    From </th>
                                <td mat-cell *matCellDef="let row" class="w-25 wallet-id">{{row.bid_by |
                                    slice:0:3}}....{{row.bid_by | slice:-4}} </td>
                            </ng-container>

                            <ng-container matColumnDef="Date">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-25 text-capitialize">
                                    Date </th>
                                <td mat-cell *matCellDef="let row" class="w-25"> {{row.bid_date}} </td>
                            </ng-container>

                            <ng-container matColumnDef="To">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-25 text-capitialize"> To
                                </th>
                                <td mat-cell *matCellDef="let row" class="w-25 wallet-id">{{row.bid_to |
                                    slice:0:3}}....{{row.bid_to | slice:-4}} </td>
                            </ng-container>



                            <tr mat-header-row *matHeaderRowDef="displayedColumnsAuction"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsAuction;"></tr>
                        </table>
                        <div class="d-flex justify-content-center align-items-center"
                            *ngIf="auctionDetails?.length == 0">
                            No Records Found
                        </div>
                    </ng-container>
                </div>
            </div>

        </div>
    </section>
    <mat-paginator #auctionPaginator [pageSizeOptions]="[5,10,25,100]" showFirstLastButtons
        [hidden]="dataSourceAuction.data?.length <= 5">
    </mat-paginator>

    <div class="rightsidenav" *ngIf="opendata">
        <div class="top-line-bg">
            <h2 class="d-inline-block text-capitialize"> Payment </h2>
            <i class="fa fa-close pull-right pointer fs-22" (click)="closeSideMenu()"></i>
            <!-- <img class="close-icon-subscribe" src="assets/Live-Stream-assets/close-icon-white.svg"
               "> -->
        </div>
        <div>
            <div class="box-content">
                <h2 class="h2" *ngIf="nftData.saleType == 'auction'">Purchase price</h2>
                <h2 class="h2" *ngIf="nftData.saleType != 'auction'">Enter the copies</h2>
                <div class="rw1">
                    <div class="display-cmt-con">
                        <div class="cl1">
                            <div>
                                <img class="img1" src="{{cryptoSymbol}}" width="20"
                                    *ngIf="nftData.saleType=='auction'" />
                                <div *ngIf="nftData.saleType!='auction'">Total</div>
                            </div>
                        </div>
                        <div class="cl2">
                            <input type="number" class="cl2" [(ngModel)]="nftBuyPrice" min="1"
                                oninput="validity.valid||(value='');" *ngIf="nftData.saleType == 'instant'">
                            <input type="number" class="cl2" [(ngModel)]="nftBidPrice" min="0.01"
                                step="0.000000000000000001" *ngIf="nftData.saleType == 'auction'"
                                (input)="bidValidation()">
                        </div>
                        <div class="cl3 d-flex justify-content-center">
                            <div *ngIf="nftData.saleType=='auction'" class="pl-1">{{selectedToken ==='GFL' ? selectedToken : clientDetailsName ==='BigbeeAI' ? 'BB' : 'KO+'}}</div>
                            <div *ngIf="nftData.saleType!='auction'">Copies</div>
                        </div>
                    </div>
                    <mat-error *ngIf="nftAvailableCopies < nftBuyPrice && nftData.saleType!='auction'"
                        class="mt-1 fs-14">Copies not available</mat-error>
                    <mat-error *ngIf="bidValidator && nftData.saleType=='auction'" class="mt-1 fs-14">
                        Please enter amount greater than the highest bid
                    </mat-error>
                </div>
                <div class="Para text-right mt-5"
                    *ngIf="nftData.nftType == 'multiple' || nftData.nftType == 'multibatch'">Available copies:
                    {{nftAvailableCopies}}</div>
                <div class="Para text-right mt-5" *ngIf="nftData.saleType == 'auction'">Highest Bid: <img
                        src={{cryptoSymbol}} class="mb-1 ml-1" width="14" /> {{highestBid > 0 ?
                    highestBid : nftData.salePrice}} {{selectedToken ==='GFL' ? selectedToken : clientDetailsName ==='BigbeeAI' ? 'BB' : 'KO+'}}</div>
                <div class="Para text-right mt-5" *ngIf="nftData.saleType == 'auction'">Current Bid :<img
                        src={{cryptoSymbol}} class="mb-1 ml-1" width="14" /> {{
                    nftBidInfo?.length>0 ? nftBidInfo[0].price : 0}} {{selectedToken ==='GFL' ? selectedToken : clientDetailsName ==='BigbeeAI' ? 'BB' : 'KO+'}}</div>
                <h1 class="h11">Overall Summary</h1>
                <div class="rw2">
                    <div class="order-s-con" *ngIf="nftData.saleType=='auction' && nftBidInfo.length>0">
                        <div class="o-l">
                            <div class="l-h2">Previous bid:</div>
                        </div>
                        <div class="o-r text-right" *ngIf="nftBidInfo.length>0">
                            <div class="l-cl1"><img class="img1 mb-1" src="{{cryptoSymbol}}">
                                <span>{{nftBidInfo[0].price}} {{nftData.token_type ==='GFL' ? nftData.token_type : clientDetailsName ==='BigbeeAI' ? 'BB' :cryptoToken}}</span>
                                <span>({{nftBidPreviousPrice | currency : getCurrency}})</span>
                            </div>
                        </div>
                    </div>
                    <div class="order-s-con">
                        <div class="o-l">
                            <div class="l-h2">Purchase Price:</div>
                        </div>
                        <div class="o-r text-right">
                            <div class="l-cl1"><img class="img1 mb-1" src="{{cryptoSymbol}}">
                                <span *ngIf="nftData.saleType=='auction'">{{nftBidPrice | number: '1.2-3' }}</span>
                                <span *ngIf="nftData.saleType!='auction'">{{ nftData.reSalePrice ? nftData.reSalePrice *
                                    nftBuyPrice : nftData.salePrice * nftBuyPrice | number:
                                    '1.2-4'}}</span>
                                <!-- <span class="cl3 align-middle">({{event.sale_price}})</span> -->
                                <span>&nbsp;{{selectedToken ==='GFL' ? selectedToken : clientDetailsName ==='BigbeeAI' ? 'BB' : 'KO+'}}</span>
                                <div *ngIf="nftData.saleType=='auction'">({{nftBidFiatPrice | currency :
                                    getCurrency}})</div>
                                <span *ngIf="nftData.saleType!='auction'"> ({{ (nftData.reSalePrice ? nftBuyPrice *
                                    nftFiatPrice1 : nftBuyPrice * nftFiatPrice) | currency :
                                    getCurrency}})</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="order-s-con">
                        <div class="o-l">
                            <div class="l-h2">Gas Fee:</div>
                        </div>
                        <div class="o-r text-right">
                            <div class="l-cl1"><img class="img1" src="assets/1200x630wa.jpg">1AREV <span
                                    class="cl3 align-middle">(${{event.sale_price}})</span></div>
                        </div>
                    </div> -->
                    <hr>
                    <div class="order-s-con">
                        <div class="o-l">
                            <div class="total-h">Total Amount : </div>
                        </div>
                        <div class="o-r text-right">
                            <div class="l-cl1"><img class="img1 mb-1" src="{{cryptoSymbol}}">
                                <span
                                    *ngIf="nftData.saleType=='auction' && nftBidInfo && nftBidInfo.length>0"><span *ngIf="checkDecimals(nftBidPrice + nftBidInfo[0].price)" matTooltip="approximately">&cong; </span> {{nftBidPrice
                                    + nftBidInfo[0].price | number:
                                    '1.2-3'}}</span>
                                <span
                                    *ngIf="nftData.saleType=='auction' && nftBidInfo && nftBidInfo.length==0"><span *ngIf="checkDecimals(nftBidPrice)" matTooltip="approximately">&cong; </span>{{nftBidPrice | number:'1.2-3'}}</span>
                                <span *ngIf="nftData.saleType!='auction'">{{ nftData.reSalePrice ? nftData.reSalePrice *
                                    nftBuyPrice : nftData.salePrice * nftBuyPrice | number:
                                    '1.2-2'}}</span>
                                <span>&nbsp;{{selectedToken ==='GFL' ? selectedToken : clientDetailsName ==='BigbeeAI' ? 'BB' : 'KO+'}}</span>
                                <div *ngIf="nftData.saleType=='auction'">({{totalBidFiatPrice | currency :
                                    getCurrency}})</div>
                                <span *ngIf="nftData.saleType!='auction'"> ({{ (nftData.reSalePrice ? nftBuyPrice *
                                    nftFiatPrice1 : nftBuyPrice * nftFiatPrice) | currency :
                                    getCurrency}})</span>
                                <!-- <span class="t-cl3 align-middle">(${{event.sale_price}})</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <label>
                    <input type="radio" name="radio-button" value="css"  />
                    <span class="para1">By checking the box,I agree to the Areavea's.</span>
                    <p class="para2">Terms & Services</p>
                </label> -->
                <div class="Para text-right mt-10 mb-20">Available Balance: <span matTooltipPosition="below"
                        matTooltip="{{available_balance}}" class="mr-1"> <img class="pr-1 mb-1" src="{{cryptoSymbol}}"
                            width="18" />{{crypto_balance}} {{selectedToken ==='GFL' ? selectedToken : clientDetailsName ==='BigbeeAI' ? 'BB' : 'KO+'}}</span></div>

                <mat-radio-group aria-label="Select an option" class="mt-20 nft-product-terms">
                    <mat-radio-button (change)="termsAndConditions($event)" value="true" class="fw-500 fs-14 d-flex align-items-center">
                      <span class="para1"> &nbsp; I agree to the&nbsp;</span> 
                      <span class="para2" (click)="openConsumerAcceptTeams('agrees')" >
                        Terms & Conditions
                      </span>
                    </mat-radio-button>
                  </mat-radio-group>

                  
                <div class="bg-secondary mb-15" *ngIf="show_TC">
                    <app-event-terms-conditions></app-event-terms-conditions>
                </div>
                <div class="btns">
                    <button type="button" class="btn1" *ngIf="nftData.saleType=='auction'">
                        <span *ngIf="nftBidInfo?.length>0 " (click)=" OnUpdateBid()">Increase
                            Bid</span>
                        <span *ngIf="nftBidInfo?.length == 0 " (click)=" OnMakeBid()">Make
                            Bid</span>
                    </button>
                    <button type="button" class="btn1" (click)=" OnBuy()"
                        *ngIf="nftData.saleType!='auction' || nftData.saleType=='lazymint'">Buy</button>
                    <!-- <button type="button" class="btn2" disabled>Add Funds</button> -->
                </div>
            </div>
        </div>
    </div>

</div>